<div class="card panel-default container-fluid">
  <!--page Header-->
  <div class="block">
    <div class="title-tab-step" style="text-align: center;">
      {{ 'المستخدم الحالي' | translate }} : {{currentUserData.userName}}
    </div>

  </div>
</div>
<div class="">
  <div class="container-fluid" dir="rtl">
    <div class="row">
      <div class="col-lg-4 col-md-7 col-xs-12">
        <div dir="rtl">
          <!-- popup auth -->
          <div *ngIf="!authResult" [ngClass]="{'d-none': showMessage}"
            class="alert alert-danger text-white text-center error-span" style="
                      box-shadow: 2px 8px 14px rgba(255, 0, 0, 0.25);
                      width: max-content;
                      background-color: #dc3545;
                      cursor: pointer;
                      border-color: #dc3545;" (click)="showMessage = true;">

            <span class="fas fa-exclamation-triangle" style="
                          display: unset;
                          margin: 0;
                          color: #fff;
                          font-family: Font Awesome\ 5 Free !important;
                          font-size: medium;"></span> {{errorMsg}}
          </div>

          <span>Please Enter User Name & Password</span>

          <div class="row m-0 mb-3">
            <i class="fa fa-user-o"></i>
            <input class="login-inputs" id="username" #userName="ngModel" required [(ngModel)]="loginModel.userName"
              type="text" autocomplete="off" placeholder="User Name" name="username" />
          </div>
          <div class="row m-0 mb-3">
            <i class="fa fa-lock"></i>
            <input class="login-inputs" [(ngModel)]="loginModel.password" id="password" #password="ngModel" required
              type="password" placeholder="Password" autocomplete="off" />
          </div>

          <div class="row m-0 mb-3" style="text-align: center;">
            <button  (click)="confirmUserSignature()"
              style="border-radius: 5px;">Confirm User
              Signature</button>

          </div>
          <!--row-->


        </div>
      </div>
      <div class="col-md-5"></div>
    </div>
  </div>
  <!--login-box-->

  <!-- <div class="col-12">
      <div class="copyright">All Copyright Reserved To Selat &#169; 2020</div>
  </div> -->
</div>